import { formatAverage, HeadcountResult, HeadcountValues } from "models/hr-dashboard";
import MonthHeader from "./month-header";

interface HeadcountTableProps {
    data: HeadcountResult;
    label?: string;
    showAverage?: boolean;
}

const ROWS: { label: string; key: keyof HeadcountValues; bold?: boolean; ytd?: boolean }[] = [
    { label: "HC beginning of month", key: "hcBegin" },
    { label: "Hired", key: "hired", ytd: true },
    { label: "Left", key: "left", ytd: true },
    { label: "Balance end of month", key: "hcEnd", bold: true },
    { label: "Average per month", key: "avgHc" },
];

const HeadcountTable = ({ data, label = "Employees", showAverage = false }: HeadcountTableProps) => (
    <div className="table-responsive">
        <table className="table table-sm table-bordered mb-0">
            <MonthHeader months={data.months} fiscalYear={data.fiscalYear} label={label} />
            <tbody>
                {ROWS.filter(r => r.key !== "avgHc" || showAverage).map(row => (
                    <tr key={row.key} className={row.bold ? "fw-bold" : undefined}>
                        <td>{row.label}</td>
                        {data.months.map(m => (
                            <td key={m.key} className="text-end">
                                {m.values ? formatAverage(m.values[row.key]) : "—"}
                            </td>
                        ))}
                        <td className="text-end fw-bold">
                            {row.ytd && data.ytd ? data.ytd[row.key] : ""}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);

export default HeadcountTable;
